<template>
  <Content class="col-span-full" :router="{
    name: 'DRIVER_LIST',
  }">
    <el-steps :active="active" :space="200" simple finish-status="success" class="mb-8">
      <el-step :title="$t('PERSONAL_INFO')" icon="el-icon-user-solid"></el-step>
      <el-step :title="$t('CONTACT_INFO')" icon="el-icon-phone"></el-step>
      <el-step :title="$t('EMPOYMENT_INFO')" icon="el-icon-office-building"></el-step>
    </el-steps>

    <PersonalInfo v-if="active === 0" :ruleForm="ruleForm" :loading="loading" @next="next($event)"
      @ruleForm="ruleForm = $event" />
    <ContactInfo v-if="active === 1" :ruleForm="ruleForm" :loading="loading" @next="next($event)"
      @ruleForm="ruleForm = $event">
      <el-button v-if="active != 0" @click="back" style="margin-left: 10px !important" class="mx-2">
        {{ $t("PREV_FORM") }}
      </el-button>
    </ContactInfo>
    <EmploymentInfo v-if="active === 2" :ruleForm="ruleForm" :loading="loading" @next="submitForm($event)"
      @ruleForm="ruleForm = $event" @resetForm="resetFields">
      <el-button v-if="active != 0" @click="back" style="margin-left: 10px !important" class="mx-2">
        {{ $t("PREV_FORM") }}
      </el-button>
    </EmploymentInfo>
  </Content>
</template>
<script>
import { resetForm } from "@/mixins/resetForm";
import { jalaliToGregorian } from "@/mixins/jalaliToGregorian";
import { editDriver, addDriver } from "@/api/drivers";

import PersonalInfo from "@/components/driver/personal.vue";
import ContactInfo from "@/components/driver/contact.vue";
import EmploymentInfo from "@/components/driver/Employment.vue";

export default {
  mixins: [resetForm, jalaliToGregorian],
  props: {
    driver: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      active: 0,
      ruleForm: {
        first_name: "",
        last_name: "",
        disabled: false,
        father_name: "",
        birthdate: null,
        national_id: "",
        mobile: "",
        driving_license_type: "",
        has_certificate_of_non_addiction: false,
        driving_license_id: "",
        status: {
          id: "",
        },
        employee_id: "",
        credit_card_number: "",
        driving_license_expiry_date: "",
        email: "",
        gender: {
          id: 1
        },
        education: {
          id: ''
        },
        marital_status: {
          id: ''
        },
        health_license_expiry_date: null,
        blood_type: {
          id: ''
        },
        contract_date: null,
        personal_photo: [],
        health_card_photo: [],
        description: "",
        number_of_children: null,
        term_of_the_contract: "",
        has_smart_card: false,
        hourly_salary: "",
        address: {
          postal_address: "",
          postal_code: "",
          province: {
            id: "",
          },
          city: {
            id: "",
          },
          neighborhood: {
            id: "",
          },
        },
      },
    };
  },
  watch: {
    driver(val) {
      this.ruleForm = val;
    },
  },
  methods: {
    submitForm(formName) {
      const actionPayload = {
        first_name: this.ruleForm.first_name,
        last_name: this.ruleForm.last_name,
        birthdate: this.jalaliToGregorian(
          this.ruleForm.birthdate,
          this.$i18n.locale
        ),
        gender: this.ruleForm.gender.id,
        father_name: this.ruleForm.father_name,
        number_of_children: this.ruleForm.number_of_children,
        national_id: this.ruleForm.national_id,
        employee_id: this.ruleForm.employee_id,
        marital_status: this.ruleForm.marital_status.id,
        mobile: this.ruleForm.mobile.substring(1),
        address: {
          postal_code: this.ruleForm.address.postal_code,
          postal_address: this.ruleForm.address.postal_address,
          province: this.ruleForm.address.province.id,
          city: this.ruleForm.address.city.id,
          country: 1,
          neighborhood: this.ruleForm.address.neighborhood.id,
        },
        education: this.ruleForm.education.id,
        credit_card_number: this.ruleForm.credit_card_number,
        status: this.ruleForm.status.id,
        hourly_salary: this.ruleForm.hourly_salary,
        driving_license_id: this.ruleForm.driving_license_id,
        driving_license_type: this.ruleForm.driving_license_type,
        driving_license_expiry_date:
          this.ruleForm.driving_license_expiry_date != ""
            ? this.jalaliToGregorian(
              this.ruleForm.driving_license_expiry_date,
              this.$i18n.locale
            )
            : null,
        health_license_id: this.ruleForm.health_license_id,
        health_license_expiry_date: this.jalaliToGregorian(
          this.ruleForm.health_license_expiry_date,
          this.$i18n.locale
        ),
        blood_type: this.ruleForm.blood_type.id,
        contract_date: this.jalaliToGregorian(
          this.ruleForm.contract_date,
          this.$i18n.locale
        ),
        term_of_the_contract: this.ruleForm.term_of_the_contract,
        has_smart_card: this.ruleForm.has_smart_card,
        description: this.ruleForm.description,
        id: this.driver != undefined ? this.$route.params.id : "",
        email: this.ruleForm.email,
        has_certificate_of_non_addiction:
          this.ruleForm.has_certificate_of_non_addiction,
      };
      var dispatchFunc = this.driver == null ? addDriver : editDriver;
      dispatchFunc.api(actionPayload).then((res) => {
        if (res) {
          this.$notify.success({
            title:
              this.$t(this.$route.name) + " " + this.$t("SUCCESSFULLY_DONE"),
            duration: 5000,
            customClass: "succ_msg",
          });
          if (this.driver == null) {
            this.resetFields();
            this.active = 0;
          } else
            this.$router.push({
              name: "DRIVER_LIST",
            });
        }
      });
    },
    next(event = null) {
      if (event) {
        if (this.active++ > 2) this.active = 1;
        return;
      }
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$refs["ruleForm"].clearValidate();
          if (this.active++ > 2) this.active = 1;
        }
      });
    },
    back() {
      if (this.active-- < 1) this.active = 1;
    },
    resetFields() {
      this.ruleForm = {
        first_name: "",
        last_name: "",
        father_name: "",
        birthdate: null,
        national_code: "",
        mobile: "",
        driving_license_type: 1,
        has_certificate_of_non_addiction: false,
        driving_license_id: "",
        health_license_id: "",
        working: true,
        employee_id: "",
        credit_card_number: "",
        driving_license_expiry_date: "",
        alley: "",
        gender: {
          id: ''
        },
        blood_type: {
          id: ''
        },
        education: {
          id: ''
        },
        marital_status: {
          id: ''
        },
        health_license_expiry_date: null,
        contract_date: null,
        personal_photo: [],
        health_card_photo: [],
        description: "",
        number_of_children: null,
        term_of_the_contract: "",
        address: {
          postal_address: "",
          postal_code: "",
          province: {
            id: "",
          },
          city: {
            id: "",
          },
          neighborhood: {
            id: "",
          },
        },
      };
    },
  },

  components: {
    PersonalInfo,
    ContactInfo,
    EmploymentInfo,
  },
};
</script>
